import { verbozify } from '@/js/helpers/verbozify'

// convert 'camelCaseValue' to 'camel case value'
export function readableCamelCase (value) {
  const spacedValue = value.replace(/([A-Z])/g, ' $1').toLowerCase()
  return verbozify(spacedValue)
}
